import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../assets/promiseFrame/268V_Icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-36f9f5ae")

_pushScopeId("data-v-36f9f5ae")
const _hoisted_1 = { class: "headTip" }
const _hoisted_2 = { class: "topText" }
const _hoisted_3 = { class: "topText_flex" }
const _hoisted_4 = {
  key: 0,
  class: "brandlogo_wrapper"
}
const _hoisted_5 = { class: "topText_one" }
const _hoisted_6 = {
  key: 1,
  class: "topText_xny"
}
const _hoisted_7 = { class: "ptb5" }
const _hoisted_8 = {
  key: 0,
  class: "productname_wrapper productname_bg"
}
const _hoisted_9 = { class: "topText_small" }
const _hoisted_10 = { class: "topText_small" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "topText_small_shallow" }, "*车型信息仅供参考，请以实车为准", -1)
const _hoisted_12 = { class: "head_promise_result_wrap" }
const _hoisted_13 = { class: "head_promise_wrapper" }
const _hoisted_14 = { class: "vector_description" }
const _hoisted_15 = { class: "result_wrap" }
const _hoisted_16 = { class: "resBox_top" }
const _hoisted_17 = { class: "reportLevel" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-gantanhao" }, null, -1)
const _hoisted_19 = { class: "top_levelDes" }
const _hoisted_20 = { class: "resbox_bottom" }
const _hoisted_21 = { class: "rectangle_resBox" }
const _hoisted_22 = {
  key: 0,
  class: "rectangle_resBox_item"
}
const _hoisted_23 = { class: "rectangle_resBox_item_txt" }
const _hoisted_24 = {
  key: 1,
  class: "rectangle_resBox_item"
}
const _hoisted_25 = { class: "rectangle_resBox_item_txt" }
const _hoisted_26 = {
  key: 2,
  class: "rectangle_resBox_item"
}
const _hoisted_27 = { class: "rectangle_resBox_item_txt" }
const _hoisted_28 = {
  key: 3,
  class: "rectangle_resBox_item"
}
const _hoisted_29 = { class: "rectangle_resBox_item_txt" }
const _hoisted_30 = { class: "result_bottom" }
const _hoisted_31 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_0
}, null, -1)
const _hoisted_32 = { class: "toc_ui__headTip_content_report_num" }
const _hoisted_33 = { class: "batteryPop" }
const _hoisted_34 = { class: "batteryPopTitle" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 评分说明 ")
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "batteryPopTitleLine" }, null, -1)
const _hoisted_37 = { class: "batteryPopCont" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "batteryPopContTitle" }, [
  /*#__PURE__*/_createVNode("i", { class: "batteryPopContTitleLine" }),
  /*#__PURE__*/_createVNode("span", { class: "batteryPopContTitleTxt" }, "综合车况")
], -1)
const _hoisted_39 = { class: "scoreLevelList" }
const _hoisted_40 = { class: "scoreLevelItem" }
const _hoisted_41 = { class: "scoreLevelInfo" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "外观少许细微划痕，无修复痕迹；内饰近乎全新，无明显使用痕迹；发动机、变速箱运行工况优异；电气设备功能正常。", -1)
const _hoisted_43 = { class: "scoreLevelItem" }
const _hoisted_44 = { class: "scoreLevelInfo" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "外观仅有少许外观缺陷及钣喷痕迹，不影响整体美观；内饰有轻微使用痕迹，整体干净整洁；发动机、变速箱工况稳定；全车电器设备功能正常，无重要部件故障损伤。", -1)
const _hoisted_46 = { class: "scoreLevelItem" }
const _hoisted_47 = { class: "scoreLevelInfo" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "外观多处缺陷，部分区域有钣喷痕迹；内饰磨损痕迹明显；车辆部分零部件开始老化，偶尔会出现一些故障。", -1)
const _hoisted_49 = { class: "scoreLevelItem" }
const _hoisted_50 = { class: "scoreLevelInfo" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "外观缺陷较多，影响整体美观；内饰磨损严重，局部出现破损；发动机、变速箱损耗明显，伴有漏油、异响等状况；车辆维修成本逐步上升。", -1)
const _hoisted_52 = { class: "scoreLevelItem" }
const _hoisted_53 = { class: "scoreLevelInfo" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "scoreLevelDesc" }, "外观大量钣金修复，缺陷极多；内饰磨损重度，破损严重；发动机、变速箱伴有重度漏油及明显异响，存在行驶安全隐患；底盘松散老化严重；大部分电气设备失效，后续整备与维修成本高昂。", -1)
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"batteryPopContTitle\" data-v-36f9f5ae><i class=\"batteryPopContTitleLine\" data-v-36f9f5ae></i><span class=\"batteryPopContTitleTxt\" data-v-36f9f5ae>事故等级</span></div><div class=\"accidentLevelList\" data-v-36f9f5ae><div class=\"accidentLevelItem\" data-v-36f9f5ae><div class=\"accidentLevelIcon level-a\" data-v-36f9f5ae>A</div><div class=\"accidentLevelDesc\" data-v-36f9f5ae>全车结构件、加强件无事故损伤或修复、覆盖件（塑料件除外）无修复，无火烧，无泡水</div></div><div class=\"accidentLevelItem\" data-v-36f9f5ae><div class=\"accidentLevelIcon level-b\" data-v-36f9f5ae>B</div><div class=\"accidentLevelDesc\" data-v-36f9f5ae>全车结构件无事故损伤或修复，加强件无烧焊、切割修复，允许覆盖件有修复，无火烧，无泡水</div></div><div class=\"accidentLevelItem\" data-v-36f9f5ae><div class=\"accidentLevelIcon level-c\" data-v-36f9f5ae>C</div><div class=\"accidentLevelDesc\" data-v-36f9f5ae>全车结构件无事故损伤或修复，加强件有烧焊修复，无火烧，无泡水</div></div><div class=\"accidentLevelItem\" data-v-36f9f5ae><div class=\"accidentLevelIcon level-c\" data-v-36f9f5ae>D</div><div class=\"accidentLevelDesc\" data-v-36f9f5ae>全车结构件有事故损伤或修复、或加强件有切割修复、或有火烧、或有泡水</div></div></div>", 2)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.getData('brandLogo'))
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  src: _ctx.getData('brandLogo'),
                  class: "topText_brandlogo"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getData('brandName')), 1),
          (_ctx.getData('energyType') === '2')
            ? (_openBlock(), _createBlock("div", _hoisted_6, "新能源"))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            (_ctx.getData('detectItem'))
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("span", {
                    class: "productname_font productname",
                    text: _ctx.getData('detectItem')
                  }, _toDisplayString(_ctx.getData("detectItem")), 9, ["text"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.getData("modelName")), 1),
        _createVNode("div", _hoisted_10, "VIN: " + _toDisplayString(_ctx.getData("VIN")), 1),
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        (_ctx.state.showProtect)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "head_promise_bg head_promise_bg_699",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toExplain()))
            }, [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("img", {
                    class: "vector",
                    src: require('../../../../../assets/promiseFrame/headVector.png'),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("span", {
                    class: "promiseMsg head_promise_font_499",
                    text: _ctx.state.promiseTxt
                  }, _toDisplayString(_ctx.getData('serviceOneTitleH5')), 9, ["text"])
                ]),
                _createVNode("img", {
                  class: "headArrowRight",
                  src: require('../../../../../assets/promiseFrame/headArrowRight.png'),
                  alt: ""
                }, null, 8, ["src"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: ["head_result_bg", {'head_result_sf_bg': _ctx.state.showProtect,
                'head_result_sf_bg_noguarantee result_bg_nosf': !_ctx.state.showProtect}]
        }, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", {
              class: ["result_middle", {"result_middle_nosf": !_ctx.state.showProtect}]
            }, [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("h5", {
                    class: "levelTxt",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changePop && _ctx.changePop(...args)))
                  }, [
                    _createVNode("img", {
                      class: "levelNum",
                      src: require(`../../../../../assets/promiseFrame/${_ctx.getData('rank')}.png`),
                      alt: ""
                    }, null, 8, ["src"]),
                    _hoisted_18
                  ])
                ]),
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.getData('rankDesc')), 1)
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("ul", _hoisted_21, [
                  (_ctx.getData('accidentFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_22, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('accidentFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_23, _toDisplayString(_ctx.getData('accidentFlag')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getData('fireFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_24, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('fireFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_25, _toDisplayString(_ctx.getData('fireFlag')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getData('waterFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_26, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('waterFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_27, _toDisplayString(_ctx.getData('waterFlag')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getData('adjustFlag', 'additionUrl'))
                    ? (_openBlock(), _createBlock("li", _hoisted_28, [
                        _createVNode("img", {
                          src: require(`../../../../../assets/promiseFrame/${_ctx.getData('adjustFlag', 'additionUrl')}`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("p", _hoisted_29, _toDisplayString(_ctx.getData('adjustFlag')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2),
            _createVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode("span", _hoisted_32, " NO." + _toDisplayString(_ctx.getData('reportCode')) + " " + _toDisplayString(_ctx.getData('reportGenDate') ? `| ${_ctx.getData('reportGenDate').replace(/-/g,'.')}` : ''), 1)
            ])
          ])
        ], 2)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.state.isShowPop,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.isShowPop = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode("i", {
              class: "iconfont icon-guanbi",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changePop && _ctx.changePop(...args)))
            })
          ]),
          _hoisted_36,
          _createVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/95.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_42
              ]),
              _createVNode("div", _hoisted_43, [
                _createVNode("div", _hoisted_44, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/80.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_45
              ]),
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/65.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_48
              ]),
              _createVNode("div", _hoisted_49, [
                _createVNode("div", _hoisted_50, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/50.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_51
              ]),
              _createVNode("div", _hoisted_52, [
                _createVNode("div", _hoisted_53, [
                  _createVNode("img", {
                    class: "scoreLevelNum",
                    src: require('../../../../../assets/promiseFrame/35.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_54
              ])
            ]),
            _hoisted_55
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})